export const TEXT_AREA_TOOLBAR = {
  TEXT_COLOR_TOOLTIP: {
    key: 'TEXT_COLOR_TOOLTIP',
    value: 'Color',
  },
  TEXT_BACKGROUND_COLOR_TOOLTIP: {
    key: 'TEXT_BACKGROUND_COLOR_TOOLTIP',
    value: 'Background color',
  },
  TEXT_BOLD_TOOLTIP: {
    key: 'TEXT_BOLD_TOOLTIP',
    value: 'Bold',
  },
  TEXT_ITALIC_TOOLTIP: {
    key: 'TEXT_ITALIC_TOOLTIP',
    value: 'Italic',
  },
  TEXT_UNDERLINE_TOOLTIP: {
    key: 'TEXT_UNDERLINE_TOOLTIP',
    value: 'Underline',
  },
  TEXT_LINK_TOOLTIP: {
    key: 'TEXT_LINK_TOOLTIP',
    value: 'Link',
  },
  TEXT_FONT_TOOLTIP: {
    key: 'TEXT_FONT_TOOLTIP',
    value: 'Font',
  },
  TEXT_FONT_SIZE_TOOLTIP: {
    key: 'TEXT_FONT_SIZE_TOOLTIP',
    value: 'Font size',
  },
  TEXT_SPACING_TOOLTIP: {
    key: 'TEXT_SPACING_TOOLTIP',
    value: 'Spacing',
  },
  TEXT_LINE_HEIGHT_LABEL: {
    key: 'TEXT_LINE_HEIGHT_LABEL',
    value: 'Line height',
  },
  TEXT_LETTER_SPACING_LABEL: {
    key: 'TEXT_LETTER_SPACING_LABEL',
    value: 'Letter spacing',
  },
  TEXT_ALIGNMENT_LABEL: {
    key: 'TEXT_ALIGNMENT_LABEL',
    value: 'Alignment',
  },
  TEXT_LIST_TOOLTIP: {
    key: 'TEXT_LIST_TOOLTIP',
    value: 'List',
  },
  TEXT_NUMBERED_LIST_TOOLTIP: {
    key: 'TEXT_NUMBERED_LIST_TOOLTIP',
    value: 'Numbered list',
  },
  TEXT_BULLETED_LIST_TOOLTIP: {
    key: 'TEXT_BULLETED_LIST_TOOLTIP',
    value: 'Bulleted list',
  },
  TEXT_INDENT_MORE_TOOLTIP: {
    key: 'TEXT_INDENT_MORE_TOOLTIP',
    value: 'Indent more',
  },
  TEXT_INDENT_LESS_TOOLTIP: {
    key: 'TEXT_INDENT_LESS_TOOLTIP',
    value: 'Indent less',
  },
};

export const ELEMENTS_SETTINGS_TOOLBAR = {
  ELEMENT_BACKGROUND_TOOLTIP: { key: 'ELEMENT_BACKGROUND_TOOLTIP', value: 'Element background color' },
  ELEMENT_COLOR_TOOLTIP: { key: 'ELEMENT_COLOR_TOOLTIP', value: 'Color' },
  ELEMENT_BORDER_COLOR_TOOLTIP: {
    key: 'ELEMENT_BORDER_COLOR_TOOLTIP',
    value: 'Element border color',
  },
  BORDER_WIDTH_LABEL: { key: 'BORDER_WIDTH_LABEL', value: 'Border Width' },
  ELEMENT_BORDER_WIDTH_LABEL: { key: 'ELEMENT_BORDER_WIDTH_LABEL', value: 'Element border width' },
};

export const BARCODE_TOOLBAR = {
         SWITCH_BARCODE_VARIABLE: {
           key: 'SWITCH_BARCODE_VARIABLE',
           value: 'Switch to variable / default text',
         },
         VARIABLE_LABEL: {
           key: 'VARIABLE_LABEL',
           value: 'Variable',
         },
         BARCODE_VARIABLE_DROPDOWN_PLACEHOLDER: {
           key: 'BARCODE_VARIABLE_DROPDOWN_PLACEHOLDER',
           value: 'Select a variable',
         },
         BARCODE_TEXT_PLACEHOLDER: { key: 'BARCODE_TEXT_PLACEHOLDER', value: 'Barcode text' },
         BARCODE_39_PERMITTED_CHARACTER: {
           key: 'BARCODE_39_PERMITTED_CHARACTER',
           value:'Permitted Characters for Input: Only numbers (0–9), uppercase letters (A–Z), and special characters (- . * $ / + %)',
         },
         INVALID_SELECTED_VALUE_ERROR_MESSAGE: {
          key: 'INVALID_SELECTED_VALUE_ERROR_MESSAGE',
          value:'The selected value is invalid. Please choose a valid option from the list',
        },
       };

export const TEMPLATES_DESIGN_AREA_TOOLBAR = {
  RULER_SWITCH_LABEL: { key: 'RULER_SWITCH_LABEL', value: 'Ruler' },
  DESIGN_READ_MODE_SWITCH_LABEL: { key: 'DESIGN_READ_MODE_SWITCH_LABEL', value: 'Read Mode' },
  UPLOAD_PDF_TOOLTIP: { key: 'UPLOAD_PDF_TOOLTIP', value: 'Upload PDF file' },
  UPLOADING_PDF_TOOLTIP: {
    key: 'UPLOADING_PDF_TOOLTIP',
    value: 'Uploading PDF file',
  },
  VERSION_TOOLTIP: { key: 'VERSION_TOOLTIP', value: 'Version' },
  VERSION_ENV_TOOLTIP: { key: 'VERSION_ENV_TOOLTIP', value: 'Envs' },
  VERSION_SEND_FOR_TESTING_TOOLTIP: {
    key: 'VERSION_SEND_FOR_TESTING_TOOLTIP',
    value: 'Send for Testing',
  },
  VERSION_VIEW_TEST_AND_PUBLISH_TOOLTIP: {
    key: 'VERSION_VIEW_TEST_AND_PUBLISH_TOOLTIP',
    value: 'View Test, Prod Versions',
  },
};

export const IMAGE_TOOLBAR = {
  LINE_WEIGHT_LABEL: { key: 'LINE_WEIGHT_LABEL', value: 'Line Weight' },
  LINE_DISTANCE_LABEL: { key: 'LINE_DISTANCE_LABEL', value: 'Line Distance' },
  BORDER_WIDTH_LABEL: { key: 'BORDER_WIDTH_LABEL', value: 'Border Width' },
  BORDER_RADIUS_LABEL: { key: 'BORDER_RADIUS_LABEL', value: 'Border Radius' },
};

export const TEXT_BLOCK_TOOLBAR = {

  FONT_FAMILY_TOOLTIP :{ key: 'FONT_FAMILY_TOOLTIP', value: 'Font Family' },
  FONT_SIZE_TOOLTIP :{ key: 'FONT_SIZE_TOOLTIP', value: 'Font Size' },
  TEXT_COLOR_TOOLTIP : { key : 'TEXT_COLOR_TOOLTIP', value : 'Font Color'},
  TEXT_BACKGROUND_COLOR_TOOLTIP : { key : 'TEXT_BACKGROUND_COLOR_TOOLTIP', value : 'Font Background'},
  ELEMENT_BACKGROUND_COLOR_TOOLTIP: {
    key: 'ELEMENT_BACKGROUND_COLOR_TOOLTIP',
    value: 'Element Background color',
  },
  TEXT_BOLD_TOOLTIP: {
    key: 'TEXT_BOLD_TOOLTIP',
    value: 'Bold',
  },
  TEXT_ITALIC_TOOLTIP: {
    key: 'TEXT_ITALIC_TOOLTIP',
    value: 'Italic',
  },
  TEXT_UNDERLINE_TOOLTIP: {
    key: 'TEXT_UNDERLINE_TOOLTIP',
    value: 'Underline',
  },
  TEXT_STRIKE_THROUGH_TOOLTIP: {
    key: 'TEXT_STRIKE_THROUGH_TOOLTIP',
    value: 'Strike Through',
  },
  TEXT_LINK_TOOLTIP: {
    key: 'TEXT_LINK_TOOLTIP',
    value: 'Link',
  },
  TEXT_FONT_TOOLTIP: {
    key: 'TEXT_FONT_TOOLTIP',
    value: 'Font',
  },
  TEXT_FONT_SIZE_TOOLTIP: {
    key: 'TEXT_FONT_SIZE_TOOLTIP',
    value: 'Font size',
  },
  TEXT_SPACING_TOOLTIP: {
    key: 'TEXT_SPACING_TOOLTIP',
    value: 'Spacing',
  },
  TEXT_LINE_HEIGHT_LABEL: {
    key: 'TEXT_LINE_HEIGHT_LABEL',
    value: 'Line height',
  },
  TEXT_LETTER_SPACING_LABEL: {
    key: 'TEXT_LETTER_SPACING_LABEL',
    value: 'Letter spacing',
  },
  TEXT_ALIGNMENT_LABEL: {
    key: 'TEXT_ALIGNMENT_LABEL',
    value: 'Alignment',
  },
  TEXT_LIST_TOOLTIP: {
    key: 'TEXT_LIST_TOOLTIP',
    value: 'List',
  },
  TEXT_NUMBERED_LIST_TOOLTIP: {
    key: 'TEXT_NUMBERED_LIST_TOOLTIP',
    value: 'Numbered list',
  },
  TEXT_BULLETED_LIST_TOOLTIP: {
    key: 'TEXT_BULLETED_LIST_TOOLTIP',
    value: 'Bulleted list',
  },
  TEXT_INDENT_MORE_TOOLTIP: {
    key: 'TEXT_INDENT_MORE_TOOLTIP',
    value: 'Indent more',
  },
  TEXT_INDENT_LESS_TOOLTIP: {
    key: 'TEXT_INDENT_LESS_TOOLTIP',
    value: 'Indent less',
  },

  TEXT_TRANSFORM_TOOLTIP:{
    key: 'TEXT_TRANSFORM_TOOLTIP',
    value: 'Text transform',
  },
  SUPERSCRIPT_TOOLTIP: {
    key: 'SUPERSCRIPT_TOOLTIP',
    value: 'Superscript',
  },
  SUBSCRIPT_TOOLTIP: {
    key: 'SUBSCRIPT_TOOLTIP',
    value: 'Subscript',
  }
};



export const TABLE_TOOLBAR = {
  LINE_WEIGHT_LABEL: { key: 'LINE_WEIGHT_LABEL', value: 'Line Weight' },
  LINE_DISTANCE_LABEL: { key: 'LINE_DISTANCE_LABEL', value: 'Line Distance' },
  BORDER_WIDTH_LABEL: { key: 'BORDER_WIDTH_LABEL', value: 'Border Width' },
  BORDER_RADIUS_LABEL: { key: 'BORDER_RADIUS_LABEL', value: 'Border Radius' },
  BACKGROUND_COLOR_LABEL : {key:'BACKGROUND_COLOR_LABEL',value:'Background Color'},
  BORDER_COLOR_LABEL : {key:'BORDER_COLOR_LABEL',value:'Border Color'},
  BORDER_STYLE: {key:'BORDER_STYLE', value:'Border Style'},
  TOGGLE_BORDER_LEFT : {key:'TOGGLE_BORDER_LEFT', value:'Toggle Left Border'},
  TOGGLE_BORDER_RIGHT : {key:'TOGGLE_BORDER_RIGHT', value:'Toggle Right Border'},
  TOGGLE_BORDER_TOP : {key:'TOGGLE_BORDER_TOP', value:'Toggle Top Border'},
  TOGGLE_BORDER_BOTTOM : {key:'TOGGLE_BORDER_BOTTOM', value:'Toggle Bottom Border'},
  CELL_BACKGROUND_COLOR : {key:'CELL_BACKGROUND_COLOR', value:'Cell Background Color'},
  HIDE_LEFT_BORDER_OPTION: { key: 'HIDE_LEFT_BORDER_OPTION', value: 'Hide Left Border' },
  SHOW_LEFT_BORDER_OPTION: { key: 'SHOW_LEFT_BORDER_OPTION', value: 'Show Left Border' },
  HIDE_RIGHT_BORDER_OPTION: { key: 'HIDE_RIGHT_BORDER_OPTION', value: 'Hide Right Border' },
  SHOW_RIGHT_BORDER_OPTION: { key: 'SHOW_RIGHT_BORDER_OPTION', value: 'Show Right Border' },
  HIDE_TOP_BORDER_OPTION: { key: 'HIDE_TOP_BORDER_OPTION', value: 'Hide Top Border' },
  SHOW_TOP_BORDER_OPTION: { key: 'SHOW_TOP_BORDER_OPTION', value: 'Show Top Border' },
  HIDE_BOTTOM_BORDER_OPTION: { key: 'HIDE_BOTTOM_BORDER_OPTION', value: 'Hide Bottom Border' },
  SHOW_BOTTOM_BORDER_OPTION: { key: 'SHOW_BOTTOM_BORDER_OPTION', value: 'Show Bottom Border' },
  HIDE_INNER_BORDERS_OPTIONS: { key: 'HIDE_INNER_BORDERS_OPTIONS', value: 'Hide Inner Borders' }, 
  SHOW_INNER_BORDERS_OPTIONS: { key: 'SHOW_INNER_BORDERS_OPTIONS', value: 'Show Inner Borders' },
  HIDE_OUTER_BORDERS_OPTIONS: { key: 'HIDE_OUTER_BORDERS_OPTIONS', value: 'Hide Outer Borders' },
  SHOW_OUTER_BORDERS_OPTIONS: { key: 'SHOW_OUTER_BORDERS_OPTIONS', value: 'Show Outer Borders' },
  HORIZONTAL_ALIGNMENT_LABEL: { key: 'HORIZONTAL_ALIGNMENT_LABEL', value: 'Horizontal Alignment' },
  VERTICAL_ALIGNMENT_LABEL: { key: 'VERTICAL_ALIGNMENT_LABEL', value: 'Vertical Alignment' },
  BORDERS_LABEL: { key: 'BORDERS_LABEL', value: 'Borders' },
  ALIGNMENT_LABEL: { key: 'ALIGNMENT_LABEL', value: 'Alignment' },
  CELL_SPACING_LABEL: { key: 'CELL_SPACING_LABEL', value: 'Cell spacing' },
  ALL_SIDES_LABEL: { key: 'ALL_SIDES_LABEL', value: 'All sides' },
  LEFT_LABEL: { key: 'LEFT_LABEL', value: 'Left' },
  RIGHT_LABEL: { key: 'RIGHT_LABEL', value: 'Right' },
  TOP_LABEL: { key: 'TOP_LABEL', value: 'Top' },
  BOTTOM_LABEL: { key: 'BOTTOM_LABEL', value: 'Bottom' },
  PADDING_LABEL: { key: 'PADDING_LABEL', value: 'Padding' },
};
